import _ from "lodash";
import categoryTransform from "@/store/modules/basic_program_points/transform";
import levelTransform from "@/store/modules/basic_levels/transform";
import { PROGRAM_LEVEL_STRUCTURE, PROGRAM_STATUS } from "./constants";
import moment from "moment-timezone";
import commonUtils from "@/utils/common";
import * as programConsts from "./constants";
import consts from "@/_consts";

function convertProgramModel(data) {
  let program = {
    Id: data.id,
    Name: data.name,
    OldName: data.name,
    ProgramQAStartDate: data.programQAStartDate || null,
    ProgramQAEndDate: data.programQAEndDate || null,
    previewDate: data.previewDate,
    Description: data.description,
    Logo: data.logoUrl === null ? "" : data.logoUrl,
    LandingBackgroundImageUrl:
      data.landingBackgroundImageUrl === null
        ? ""
        : data.landingBackgroundImageUrl,
    CreatedBy: data.createdBy,
    CreatedDate: data.createdDate,
    UpdatedTime: data.lastModifiedDate,
    UpdatedBy: data.lastModifiedBy,
    LastSent: data.lastSent,
    Status: data.status,
    IsEligible: data.isEligible,
    IsRetrigger: data.isRetriggerEmail,
    IsRegistered: data.isRegisteredForPlatform,
    IsSentRegistrationEmail: data.isSentRegistrationEmail,
    IsScheduledScreening: data.isScheduledScreening,
    IsScreened: data.isScreen,
    IsFunctionally: data.isFunctionally,
    Points: data.userPoint || 0,
    ScalePercent: data.scalePercent || consts.pointEconomyPercentage,
    IsUsePoints: data.isUsePoint || false,
    IsUseLevel: data.isUseLevel,
    IsHumanPerformance: data.isHp || false,
    IsCoaching: data.isCoaching || false,
    IsOutcomesLite:
      (data.programType || "") === programConsts.PROGRAM_TYPES.OUTCOMES_LITE ||
      false,
    IsOutcomes: data.isOutcomes || false,
    IsTobaccoFree: data.isTobaccoFree || false,
    ProgramCategoryPoints: data.programCategoryPoints
      ? categoryTransform.convertListPointModel(data.programCategoryPoints)
      : [],
    ServicesIncluded: data.servicesIncluded || [],
    Levels: [],
    levelsOriginalData: data.programLevels || null,
    Clients: [],
    IsTemplate: data.isTemplate,
    IsPreview: data.isPreview || data.qaVerify || false,
    IsOwner: false,
    IsSupportMilestone: data.isSupportMilestone || false,
    IsEnableMilestoneSubgroup: data.isEnableMilestoneSubgroup || false,
    PreviewTimeZone: data.previewTimeZone || null,
    StartTimeZone: data.startTimeZone,
    EndTimeZone: data.endTimeZone || null,
    ProgramLength: data.programLength ? data.programLength : 0,
    IsCompleted:
      data.status === PROGRAM_STATUS.COMPLETED ||
      data.status === PROGRAM_STATUS.CANCELLED,
    IsActive: data.status === PROGRAM_STATUS.ACTIVE,
    IsDraft: data.status === PROGRAM_STATUS.DRAFT,
    ApplyRewardAllSubgroup: data.applyRewardAllSubgroup || false,
    Color: data.colorValue || "#00A4D6",
    // WMO
    isWellMatric: data.isWellMatric || false,
    isScreen: data.isScreen || false,
    onsiteScreeningKey: data.onsiteScreeningKey || '',
    onsiteSelection: data.onsiteSelection || '',
    isOffsiteScreening: data.isOffsiteScreening || false,
    offsiteScreeningKey: data.offsiteScreeningKey || '',
    offsiteSelection: data.offsiteSelection || '',
    isEnableScheduledScreeningEvent: data.isEnableScheduledScreeningEvent || false,
    isHPSF: data.isHPSF,
    hpsfFormType: data.hpsfFormType,
    isHTK: data.isHTK,
    isQuestLabFacility: data.isQuestLabFacility || false,
    isLabcorp: data.isLabcorp || null,
    labcorpAccountNumber: data.labcorpAccountNumber,
    labcorpFileUrl: data.labcorpFileUrl,
    programHealthyRanges: data.programHealthyRanges || [],
    tobaccoSurchargeManagement: data.tobaccoSurchargeManagement || false,
    programRegisterMessage: data.programRegisterMessage,
    awardedForTobaccoAttestation: data.awardedForTobaccoAttestation,
    awardedForTobaccoRas: data.awardedForTobaccoRas,
    canAccessRasPage: data.tobaccoSurchargeManagement || false,
    canAccessHealthyRangesPage:
      (data.programType || "") === programConsts.PROGRAM_TYPES.OUTCOMES_LITE ||
      (data.programType || "") === programConsts.PROGRAM_TYPES.FULL_OUTCOMES ||
      false,
    isAppealsForm: data.isAppealsForm || false,
    appealsFormFileUrl: data.appealsFormFileUrl || "",
    appealsFormText: data.appealsFormText || "",
    demographics: data.demographics || [],
    extractable: data.extractable || false,
    wellmetricSchedulerV1Url: data.wellmetricSchedulerV1Url,
    currentProgramType: data.programType || "",
    programType: data.programType || "",
    activeDate: data.activeDate || null, // program has been activated before
    tobaccoAttestationDeadline: data.tobaccoAttestationDeadline || null,
    tobaccoProgramDeadline: data.tobaccoProgramDeadline || null,
    programMilestones: data.programMilestones || [],
    programMilestoneRewards: data.programMilestoneRewards || [],
    programStartDateMPD : data.startDate,
    programEndDateMPD : data.resetDate,
    isDemo: data.isDemo
  };
  if (data.clientPrograms && data.clientPrograms.length > 0) {
    program.Clients = convertListClientModel(data.clientPrograms);
  }
  if (data.clientId) {
    program.IsOwner =
      _.findIndex(program.Clients, i => {
        return i.ClientId === data.clientId;
      }) > -1;
  }
  if (data.tobaccoSurchargeManagement) {
    levelTransform.handleTobaccoRequirementItems(data.programLevels);
  }
  if (data.programLevels && data.programLevels.length > 0) {
    program.Levels = levelTransform.convertListLevelModel(
      data.programLevels,
      null
    );
  }
  if (
    program.Levels &&
    program.Levels.length > 0 &&
    data.programActivities &&
    data.programActivities.length > 0
  ) {
    program.Levels.forEach(level => {
      if (level.Activities && level.Activities.length > 0) {
        level.Activities.forEach(activity => {
          const index = data.programActivities.findIndex(
            t => t.activityId === activity.ActivityId
          );
          if (index >= 0) {
            activity.ProgramPhaseId =
              data.programActivities[index].programPhaseId;
            activity.ProgramPhasePhaseOrder =
              data.programActivities[index].programPhasePhaseOrder;
            activity.IsCustomized = data.programActivities[index].isCustomized;
          }
        });
      }
    });
  }
  if (data.programActivities && data.programActivities.length > 0) {
    program.ProgramActivities = data.programActivities;
  } else {
    program.ProgramActivities = [];
  }

  if (!data.startTimeZone) {
    data.startTimeZone = moment.tz.guess();
  }
  program.StartTimeZone = data.startTimeZone;
  if (data.startLocalDate && data.startLocalTime) {
    program.StartDate = commonUtils.combineDateAndTime(data.startLocalDate, data.startLocalTime);
    program.IsInvalidDate = false;
  } else {
    program.StartDate = moment()
      .add(1, "days")
      .utc()
      .format();
    program.StartDate = commonUtils.removeZFromString(program.StartDate);
    program.IsInvalidDate = true;
  }
  if (data.resetLocalDate && data.resetLocalTime) {
    program.EndDate = commonUtils.combineDateAndTime(data.resetLocalDate, data.resetLocalTime);
  } else {
    program.EndDate = moment()
      .add(1, "months")
      .utc()
      .format();
    program.EndDate = commonUtils.removeZFromString(program.EndDate);
  }
  if (data.programQAStartLocalDate && data.programQAStartLocalTime) {
    program.ProgramQAStartDate = commonUtils.combineDateAndTime(data.programQAStartLocalDate, data.programQAStartLocalTime);
  }
  if (data.programQAEndLocalDate && data.programQAEndLocalTime) {
    program.ProgramQAEndDate = commonUtils.combineDateAndTime(data.programQAEndLocalDate, data.programQAEndLocalTime);
  }
  if (data.previewLocalDateTime) {
    program.previewDate = commonUtils.removeZFromString(data.previewLocalDateTime);
  } else {
    program.previewDate = moment()
      .add(1, "days")
      .utc()
      .format();
    program.previewDate = commonUtils.removeZFromString(program.previewDate);
  }
  if (data.biometricLookbackLocalDate && data.biometricLookbackLocalTime) {
    program.BiometricLookbackDate = commonUtils.combineDateAndTime(data.biometricLookbackLocalDate, data.biometricLookbackLocalTime);
  } else {
    program.BiometricLookbackDate = moment()
      .add(1, "days")
      .utc()
      .format();
    program.BiometricLookbackDate = commonUtils.removeZFromString(program.BiometricLookbackDate);
  }
  if (data.biometricDeadlineLocalDate && data.biometricDeadlineLocalTime) {
    program.BiometricDeadlineDate = commonUtils.combineDateAndTime(data.biometricDeadlineLocalDate, data.biometricDeadlineLocalTime);
  } else {
    program.BiometricDeadlineDate = moment()
      .add(1, "days")
      .utc()
      .format();
    program.BiometricDeadlineDate = commonUtils.removeZFromString(program.BiometricDeadlineDate);
  }
  if (data.screeningEventStartLocalDate && data.screeningEventStartLocalTime) {
    program.ScreeningEventStartDate = commonUtils.combineDateAndTime(data.screeningEventStartLocalDate, data.screeningEventStartLocalTime);
  } else {
    program.ScreeningEventStartDate = moment()
      .add(1, "days")
      .utc()
      .format();
    program.ScreeningEventStartDate = commonUtils.removeZFromString(program.ScreeningEventStartDate);
  }
  if (data.screeningEventEndLocalDate && data.screeningEventEndLocalTime) {
    program.ScreeningEventEndDate = commonUtils.combineDateAndTime(data.screeningEventEndLocalDate, data.screeningEventEndLocalTime);
  } else {
    program.ScreeningEventEndDate = moment()
      .add(1, "days")
      .utc()
      .format();
    program.ScreeningEventEndDate = commonUtils.removeZFromString(program.ScreeningEventEndDate);
  }
  if (data.tobaccoAttestationDeadline) {
    program.tobaccoAttestationDeadlineLocalDate = commonUtils.getLocalDate(data.tobaccoAttestationDeadlineLocalDate);
  } else {
    program.tobaccoAttestationDeadline = moment()
      .add(1, "days")
      .utc()
      .format();
    program.tobaccoAttestationDeadlineLocalDate = commonUtils.getLocalDate(program.tobaccoAttestationDeadline);
  }
  if (data.tobaccoProgramDeadline) {
    program.tobaccoProgramDeadlineLocalDate = commonUtils.getLocalDate(data.tobaccoProgramDeadlineLocalDate);
  } else {
    program.tobaccoProgramDeadline = moment()
      .add(1, "days")
      .utc()
      .format();
    program.tobaccoProgramDeadlineLocalDate = commonUtils.getLocalDate(program.tobaccoProgramDeadline);
  }
  if (data.levelStructure) {
    program.LevelStructure = data.levelStructure;
    if (data.levelStructure === PROGRAM_LEVEL_STRUCTURE.NO_POINTS) {
      program.IsUsePoints = false;
    } else {
      program.IsUsePoints = true;
    }
  } else {
    program.LevelStructure = PROGRAM_LEVEL_STRUCTURE.LINEAR;
  }

  if (data.programSubgroups) {
    program.ProgramSubgroups = [];
    data.programSubgroups.forEach(sub => {
      program.ProgramSubgroups.push({
        Id: sub.id,
        ProgramId: sub.programId,
        ProgramName: sub.programName,
        SubgroupId: sub.subgroupId,
        SubgroupName: sub.subgroupName,
        LevelList: levelTransform.convertListLevelModel(
          data.programLevels,
          sub.subgroupId
        )
      });
    });
  }
  return program;
}

function convertProgramRawModel(data) {
  let program = {
    id: data.Id,
    name: data.Name,
    oldName: data.OldName,
    description: data.Description,
    logoUrl: data.Logo,
    landingBackgroundImageUrl: data.LandingBackgroundImageUrl,
    createdBy: data.CreatedBy,
    createdDate: data.CreatedDate,
    lastModifiedDate: data.UpdatedTime,
    lastModifiedBy: data.UpdatedBy,
    lastSent: data.LastSent,
    status: data.Status,
    isEligible: data.IsEligible,
    isRetriggerEmail: data.IsRetrigger,
    isRegisteredForPlatform: data.IsRegistered,
    isSentRegistrationEmail: data.IsSentRegistrationEmail,
    isScheduledScreening: data.IsScheduledScreening,
    isFunctionally: data.IsFunctionally,
    userPoint: data.Points && data.Points !== null ? data.Points : 0,
    scalePercent: data.ScalePercent,
    isUsePoint: data.IsUsePoints,
    isUseLevel: data.IsUseLevel,
    isHp: data.IsHumanPerformance || false,
    isCoaching: data.IsCoaching || false,
    isOutcomesLite: data.IsOutcomesLite || false,
    isOutcomes: data.IsOutcomes || false,
    isTobaccoFree: data.IsTobaccoFree || false,
    isTemplate: data.IsTemplate,
    isPreview: data.IsPreview,
    isSupportMilestone: data.IsSupportMilestone,
    isEnableMilestoneSubgroup: data.IsEnableMilestoneSubgroup || false,
    previewTimeZone: data.PreviewTimeZone,
    startTimeZone: data.StartTimeZone,
    endTimeZone: data.EndTimeZone,
    programLength: data.ProgramLength,
    colorValue: data.Color,
    tobaccoSurchargeManagement: data.tobaccoSurchargeManagement || false,
    // WMO
    isWellMatric: data.isWellMatric || false,
    isScreen: data.isScreen || false,
    onsiteScreeningKey: data.onsiteScreeningKey || '',
    onsiteSelection: data.onsiteSelection || '',
    isOffsiteScreening: data.isOffsiteScreening || false,
    offsiteScreeningKey: data.offsiteScreeningKey || '',
    offsiteSelection: data.offsiteSelection || '',
    isEnableScheduledScreeningEvent: data.isEnableScheduledScreeningEvent || false,
    isHPSF: data.isHPSF,
    isHTK: data.isHTK,
    isQuestLabFacility: data.isQuestLabFacility || false,
    isLabcorp: data.isLabcorp,
    labcorpAccountNumber: data.labcorpAccountNumber,
    labcorpFileUrl: data.labcorpFileUrl,
    programRegisterMessage: data.programRegisterMessage,
    awardedForTobaccoAttestation: data.awardedForTobaccoAttestation,
    awardedForTobaccoRas: data.awardedForTobaccoRas,
    levelStructure: data.LevelStructure,
    isAppealsForm: data.isAppealsForm || false,
    appealsFormFileUrl: data.appealsFormFileUrl || "",
    appealsFormText: data.appealsFormText || "",
    hpsfFormType: data.hpsfFormType,
    programType: data.programType,
    wellmetricSchedulerV1Url: data.isScreen ? data.wellmetricSchedulerV1Url : "",
    tobaccoAttestationDeadline: data.tobaccoAttestationDeadline || null,
    tobaccoProgramDeadline: data.tobaccoProgramDeadline || null,
    programMilestones: data.programMilestones || [],
    programMilestoneRewards: data.programMilestoneRewards || [],
    programStartDateMPD : data.startDate,
    programEndDateMPD : data.resetDate,
    isDemo: data.isDemo
  };
  let startDate = commonUtils.removeZFromString(data.StartDate),
    resetDate = commonUtils.removeZFromString(data.EndDate),
    previewDate = commonUtils.removeZFromString(data.previewDate),
    biometricLookbackDate = commonUtils.removeZFromString(data.BiometricLookbackDate),
    biometricDeadlineDate = commonUtils.removeZFromString(data.BiometricDeadlineDate),
    screeningEventStartDate = commonUtils.removeZFromString(data.ScreeningEventStartDate),
    screeningEventEndDate = commonUtils.removeZFromString(data.ScreeningEventEndDate),
    tobaccoAttestationDeadline = commonUtils.removeZFromString(data.tobaccoAttestationDeadline),
    tobaccoProgramDeadline = commonUtils.removeZFromString(data.tobaccoProgramDeadline),
    programQAStartDate = data.ProgramQAStartDate
      ? commonUtils.removeZFromString(data.ProgramQAStartDate)
      : null,
    programQAEndDate = data.ProgramQAEndDate
      ? commonUtils.removeZFromString(data.ProgramQAEndDate)
      : null;
  if (startDate && startDate.includes("T")) {
    program.startLocalDate = startDate.split("T")[0];
    program.startLocalTime = startDate.split("T")[1];
  }
  if (resetDate && resetDate.includes("T")) {
    program.resetLocalDate = resetDate.split("T")[0];
    program.resetLocalTime = resetDate.split("T")[1];
  }

  if (data.previewDate) {
    if (data.previewDate.includes('Z')) {
      program.previewDate = data.previewDate;
    } else {
      program.previewDate = commonUtils.concatZFromString(data.previewDate);
    }
  }

  program.previewLocalDateTime = previewDate;
  if (biometricDeadlineDate && biometricDeadlineDate.includes("T")) {
    program.biometricDeadlineLocalDate = biometricDeadlineDate.split("T")[0];
    program.biometricDeadlineLocalTime = biometricDeadlineDate.split("T")[1];
  }
  if (biometricLookbackDate && biometricLookbackDate.includes("T")) {
    program.biometricLookbackLocalDate = biometricLookbackDate.split("T")[0];
    program.biometricLookbackLocalTime = biometricLookbackDate.split("T")[1];
  }
  if (screeningEventStartDate && screeningEventStartDate.includes("T")) {
    program.screeningEventStartLocalDate = screeningEventStartDate.split("T")[0];
    program.screeningEventStartLocalTime = screeningEventStartDate.split("T")[1];
  }
  if (screeningEventEndDate && screeningEventEndDate.includes("T")) {
    program.screeningEventEndLocalDate = screeningEventEndDate.split("T")[0];
    program.screeningEventEndLocalTime = screeningEventEndDate.split("T")[1];
  }
  if (tobaccoProgramDeadline && tobaccoProgramDeadline.includes("T")) {
    program.tobaccoProgramDeadlineLocalDate = tobaccoProgramDeadline.split("T")[0];
  }
  if (tobaccoAttestationDeadline && tobaccoAttestationDeadline.includes("T")) {
    program.tobaccoAttestationDeadlineLocalDate = tobaccoAttestationDeadline.split("T")[0];
  }
  if (programQAStartDate && programQAStartDate.includes("T")) {
    program.programQAStartLocalDate = programQAStartDate.split("T")[0];
    program.programQAStartLocalTime = programQAStartDate.split("T")[1];
  }
  if (programQAEndDate && programQAEndDate.includes("T")) {
    program.programQAEndLocalDate = programQAEndDate.split("T")[0];
    program.programQAEndLocalTime = programQAEndDate.split("T")[1];
  }

  return program;
}

function convertListProgramModel(data) {
  let listProgram = [];
  _.forEach(data, function(item) {
    if (item) {
      listProgram.push(convertProgramModel(item));
    }
  });
  return listProgram;
}

function convertClientModel(data) {
  let client = {
    ClientId: data.clientId,
    ProgramId: data.programId,
    ClientName: data.clientName
  };
  if (data.id) {
    client.Id = data.id;
  }
  return client;
}

function convertListClientModel(data) {
  let list = [];
  data.forEach(item => {
    list.push(convertClientModel(item));
  });
  return list;
}

function convertClientRawModel(data) {
  let client = {
    clientId: data.ClientId,
    programId: data.ProgramId,
    clientName: data.ClientName,
    programSubgroups: data.ProgramSubgroups
  };
  if (data.Id) {
    client.id = data.Id;
  }
  return client;
}

function convertListClientRawModel(data) {
  let list = [];
  data.forEach(item => {
    list.push(convertClientRawModel(item));
  });
  return list;
}

function convertEmployerToClientModel(data, programId) {
  let client = {
    ClientId: data.id,
    ProgramId: programId,
    ClientName: data.name
  };
  return client;
}

function convertListEmployerToListClientModel(data, programId) {
  let list = [];
  data.forEach(item => {
    list.push(convertEmployerToClientModel(item, programId));
  });
  return list;
}

function convertProgramTobaccoDates (data) {
  if (data.tobaccoAttestationDeadline && data.tobaccoAttestationDeadline.includes('T')) {
    const tobaccoAttestationDeadline = data.tobaccoAttestationDeadline.split('T')[0];
    if (tobaccoAttestationDeadline !== data.tobaccoAttestationDeadlineLocalDate) {
      data.tobaccoAttestationDeadline = `${data.tobaccoAttestationDeadlineLocalDate}T00:00:00.000Z`;
    }
  }

  if (data.tobaccoProgramDeadline && data.tobaccoProgramDeadline.includes('T')) {
    const tobaccoProgramDeadline = data.tobaccoProgramDeadline.split('T')[0];
    if (tobaccoProgramDeadline !== data.tobaccoProgramDeadlineLocalDate) {
      data.tobaccoProgramDeadline = `${data.tobaccoProgramDeadlineLocalDate}T00:00:00.000Z`;
    }
  }
  return data;
}

export default {
  convertProgramModel,
  convertProgramRawModel,
  convertListProgramModel,
  convertListClientModel,
  convertListEmployerToListClientModel,
  convertListClientRawModel,
  convertProgramTobaccoDates
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_programs/transform.js